"use strict";
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultChartTheme = void 0;
const constants_1 = require("../constants");
exports.defaultChartTheme = {
    background: 'transparent',
    fontFamily: constants_1.themeOptions.typography.fontFamily || '"Source Sans Pro", sans-serif',
    fontSize: constants_1.themeOptions.typography.fontSize,
    axis: {
        domain: {
            line: {
                stroke: 'transparent',
                strokeWidth: 1,
            },
        },
        ticks: {
            line: {
                stroke: '#777',
                strokeWidth: 1,
            },
            text: {
                fill: constants_1.themeOptions.palette.black.main,
                fontSize: constants_1.themeOptions.typography.fontSize,
            },
        },
        legend: {
            text: {
                fill: constants_1.themeOptions.palette.black.main,
                fontSize: constants_1.themeOptions.typography.fontSize,
            },
        },
    },
    grid: {
        line: {
            stroke: '#ddd',
            strokeWidth: 1,
        },
    },
    legends: {
        text: {
            fill: constants_1.themeOptions.palette.black.main,
            fontSize: constants_1.themeOptions.typography.fontSize,
        },
    },
    labels: {
        text: {
            fill: constants_1.themeOptions.palette.black.main,
            fontSize: constants_1.themeOptions.typography.fontSize,
        },
    },
    markers: {
        lineColor: '#000',
        lineStrokeWidth: 1,
        textColor: constants_1.themeOptions.palette.black.main,
        fontSize: constants_1.themeOptions.typography.fontSize.toString(),
        text: {
            fill: constants_1.themeOptions.palette.black.main,
            fontSize: constants_1.themeOptions.typography.fontSize,
        },
    },
    dots: {
        text: {
            fill: constants_1.themeOptions.palette.black.main,
            fontSize: constants_1.themeOptions.typography.fontSize,
        },
    },
    tooltip: {
        container: {
            background: 'white',
            color: 'inherit',
            fontSize: 'inherit',
            borderRadius: '0.25rem',
            boxShadow: '0 0.0625rem 0.125rem rgba(0, 0, 0, 0.25)',
            padding: '0.3125rem 0.5625rem',
        },
        basic: {
            whiteSpace: 'pre',
            display: 'flex',
            alignItems: 'center',
        },
        table: {},
        chip: {},
        tableCell: {
            padding: '3px 5px',
        },
    },
};
//# sourceMappingURL=data:application/json;base64,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